// extracted by mini-css-extract-plugin
export var blocked = "what-module--blocked--1z0ht";
export var ___gatsby = "what-module--___gatsby--NiILM";
export var loader = "what-module--loader--35zay";
export var container = "what-module--container--1Lzwv";
export var container__content = "what-module--container__content--32J1u";
export var container__content__single = "what-module--container__content__single--xEYz9";
export var check_icon = "what-module--check_icon--4hTPh";
export var close_icon = "what-module--close_icon--2pSOA";